module.exports = __webpack_public_path__ + "media/images/product-tour-poster-6ec14eb637d1527d96cc8de918724fbe.png";